// Check if functions are already initialized to prevent multiple initializations
if (!window.productCutoffInitialized) {
  // Utility functions to replace moment.js

  window.getToday = () => {
    // Use Europe/Berlin timezone so the cutoff comparison is always relative
    // to the shop's local time, regardless of the customer's browser timezone.
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  };

  window.formatDate = (date, format = 'YYYY-MM-DD') => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    // Handle different format types
    switch (format) {
      case 'YYYY-MM-DD':
        return `${year}-${month}-${day}`;
      case 'DD.MM.YYYY':
        return `${day}.${month}.${year}`;
      case 'DD.MM.YY':
        return `${day}.${month}.${String(year).slice(-2)}`;
      case 'DD.MM.YY - HH:mm':
        return `${day}.${month}.${String(year).slice(-2)} - ${hours}:${minutes}`;
      case 'dddd, DD.MM.YYYY':
        return d.toLocaleDateString('de-DE', {
          weekday: 'long',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      default:
        return `${year}-${month}-${day}`;
    }
  };

  window.addDaysToDate = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  window.subtractDaysFromDate = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  };

  window.parseTime = (timeString) => {
    // Parse time string like "12:00" and return today's date with that time
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = window.getToday();
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  window.addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  window.subtractDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  };

  window.isBefore = (date1, date2) => {
    return date1.getTime() < date2.getTime();
  };

  window.getNextDeliveryDay = () => {
    const nextDate = new Date(window.deliveryDays.availableDates[0]);
    return window.formatDate(nextDate, 'dddd, DD.MM.YYYY');
  };

  window.getWeekday = (date) => {
    // Returns 0-6, where 0 is Sunday
    return date.getDay();
  };

  const getISOWeekday = (date) => {
    // Returns 1-7, where 1 is Monday and 7 is Sunday
    const day = date.getDay();
    return day === 0 ? 7 : day;
  };

  const isSameDay = (date1, date2) => {
    return window.formatDate(date1) === window.formatDate(date2);
  };

  const isAfter = (date1, date2) => {
    return date1 > date2;
  };

  const getWeekdayName = (date) => {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return weekdays[date.getDay()];
  };

  window.calculateDeliveryDates = (deliveryDays, feiertage, vorlauf, firstProductCutoff) => {
    const today = window.getToday();

    const todayIsWeekend = getISOWeekday(today) > 4;
    /*
     * Disable the dates according to the company Location's delivery dates and the holidays' respective alternative date
     */
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const unAvailableWeekdays = weekdays.filter((i) => !deliveryDays.includes(i));

    const basketContainsFreshCutoff = firstProductCutoff == '12:00';
    const unAvailableNextDays = [];

    let cutoffTime = null;
    if (firstProductCutoff) {
      cutoffTime = parseTime(firstProductCutoff);
    }

    if (todayIsWeekend && basketContainsFreshCutoff) {
      // add the next Sunday and Monday as a dates that cannot be delivered to
      if (getISOWeekday(today) === 5) {
        // Friday
        if (cutoffTime && isAfter(today, cutoffTime)) {
          // console.log("CHECK PRODUCT CUTOFF", firstProductCutoff);
          unAvailableNextDays.push(addDays(today, 2)); // Sunday
          unAvailableNextDays.push(addDays(today, 3)); // Monday
        }
      } else if (getISOWeekday(today) === 6) {
        // Saturday
        unAvailableNextDays.push(addDays(today, 1)); // Sunday
        unAvailableNextDays.push(addDays(today, 2)); // Monday
      } else if (getISOWeekday(today) === 7) {
        // Sunday
        unAvailableNextDays.push(addDays(today, 1)); // Monday
      }
    }

    const maxDeliveryDate = window.formatDate(addDaysToDate(today, 30));
    // const end = window.formatDate(subtractDaysFromDate(today, 2));
    const start = maxDeliveryDate;

    let disabledDates = [];
    let feiertageDates = feiertage.map((node) => node.datum?.value);
    let availableDates = [];

    let daysToAdd = 1;
    if (vorlauf) {
      daysToAdd = daysToAdd + Number(vorlauf);
    }

    const startDate = addDaysToDate(today, daysToAdd);

    // Iterate through dates from startDate to maxDeliveryDate
    const maxDate = new Date(start);
    let currentDate = new Date(startDate);

    while (currentDate <= maxDate) {
      const currentDateString = window.formatDate(currentDate);
      const weekdayName = getWeekdayName(currentDate);

      if (
        unAvailableNextDays.some((d) => isSameDay(d, currentDate)) ||
        unAvailableWeekdays.includes(weekdayName) ||
        feiertageDates.includes(currentDateString)
      ) {
        disabledDates.push(currentDateString);
      } else {
        // Check if this is tomorrow and we need to check cutoff
        const tomorrow = addDaysToDate(today, 1);
        if (cutoffTime && isSameDay(currentDate, tomorrow)) {
          console.log('CHECK PRODUCT CUTOFF', firstProductCutoff);

          if (isAfter(today, cutoffTime)) {
            console.log('CUTOFF PASSED');
            disabledDates.push(currentDateString);
            currentDate = addDaysToDate(currentDate, 1);
            continue;
          }
        }

        availableDates.push(currentDateString);
      }

      currentDate = addDaysToDate(currentDate, 1);
    }

    const end = availableDates[0]
      ? window.formatDate(subtractDaysFromDate(new Date(availableDates[0]), 1))
      : window.formatDate(subtractDaysFromDate(today, 1));

    return { start, end, disabledDates, availableDates };
  };

  // Mark as initialized and publish event once all functions are initialized
  window.productCutoffInitialized = true;
}
document.dispatchEvent(
  new CustomEvent('productCutoffInitialized', {
    detail: {
      message: 'Product cutoff functions have been successfully initialized',
      functions: ['formatDate', 'addDaysToDate', 'subtractDaysFromDate', 'parseTime', 'calculateDeliveryDates'],
      timestamp: new Date().toISOString(),
    },
  }),
);
